'use strict'

import {
	Polymer
} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {
	dom,
	flush
} from '@polymer/polymer/lib/legacy/polymer.dom.js'
import {
	html
} from '@polymer/polymer/lib/utils/html-tag.js'

Polymer({
  is: "moskito-rights-manager",
  
  properties: {
  	data: {
  		type: Object,
  		notify: true
  	}
  }
});
